import React, { useState } from 'react';
import { RegionReportItemHeader } from '../RegionReportItemHeader/RegionReportItemHeader';
import { RegionReportItems } from '../RegionReportItems/RegionReportItems';
import { LabelColor, YieldRegionReport } from '../../../../types';

export type RegionReportStatsProps = {
  allowHover?: boolean;
  areaUnit: string;
  colors?: LabelColor;
  cropCode: string;
  data?: YieldRegionReport[];
  dataTestId: string;
  headerText: string;
  locale?: string;
  onClickItem?: (item: YieldRegionReport) => void;
  showIcon?: boolean;
  index: number;
  displayRanges?: boolean;
};

export const RegionReportStats = ({
  allowHover,
  areaUnit,
  colors = [],
  cropCode,
  data = [],
  dataTestId,
  headerText,
  index,
  locale = '',
  onClickItem = () => undefined,
  showIcon = false,
  displayRanges = false,
}: RegionReportStatsProps) => {
  const [isCollapsed, toggleCollapsed] = useState(false);
  return (
    <>
      <RegionReportItemHeader
        areaUnit={areaUnit}
        cropCode={cropCode}
        headerText={headerText}
        isCollapsed={isCollapsed}
        toggleCollapsed={() => toggleCollapsed(!isCollapsed)}
      />
      {!isCollapsed && (
        <RegionReportItems
          allowHover={allowHover}
          colors={colors}
          data={data}
          dataTestId={dataTestId}
          locale={locale}
          index={index}
          onClick={onClickItem}
          showIcon={showIcon}
          displayRanges={displayRanges}
          cropCode={cropCode}
        />
      )}
    </>
  );
};


